
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  getShopGoodsClassLis,
  ShopGoodsClassListDto,
  ShopGoodsBrandListDto,
  ShopGoodsTagListDto,
  getShopGoodsBrandList,
  getShopGoodsTagList,
  newArrivalList,
  hotSaleList
} from "@/api/shoppingMall";
import {
  getGoodsListOfCategoryAPI,
  GoodsListOfCategoryDto,
  GoodsListOfCategoryFormatDto,
  SelectGoodsOptionsDto
} from "@/api/commonConfig";
import ChooseGoodsCard from "@/views/orderManage/template/ChooseGoodsCard.vue";
import BuyCarPop from "@/views/orderManage/template/BuyCarPop.vue";
import math from "@/core/math";
import CartControl from "../template/CartControl.vue";
import BuyCarDialog from "@/views/orderManage/template/BuyCarDialog.vue";
import DropItemSelector from "@/components/DropItemSelector/index.vue";
Component.registerHooks(['beforeRouteEnter']);
@Component({
  name: "ChooseGoods",
  components: {
    CartControl,
    ChooseGoodsCard,
    BuyCarPop,
    BuyCarDialog,
    DropItemSelector
  }
})
export default class ChooseGoods extends Vue {
  @Getter companyId!: string;
  @Getter selectList!: SelectGoodsOptionsDto[];
  @Action setSelectList!: (val: SelectGoodsOptionsDto[]) => void;

  customerId = ""; // 客户编号
  /* 当前选择的分类id */
  categoryId = "";
  /* 当前选择的分类parentId */
  parentId = "";
  /* 三级分类时选择的分类值 */
  threeId = "";
  /* 当前选择的分类级别 */
  currentLevel = "1";
  hierarchyId = "";
  hierarchyIdThree = "";

  // 排序字段 价格：1，销量：2，编码：3
  orderField = "";
  // 排序类型 Up:升序，Down: 降序
  orderType = "";
  sortValue = "";
  /* 排序选项列表 */
  sortOption = [
    { text: "默认排序", value: "" },
    { text: "按价格升序", value: "1-Up" },
    { text: "按价格降序", value: "1-Down" },
    { text: '按销量升序', value: '2-Up' },
    { text: "按销量降序", value: "2-Down" },
    { text: "按商品编码升序", value: "3-Up" },
    { text: "按商品编码降序", value: "3-Down" }
  ];

  /* 品牌筛选值 */
  brandValue = [];
  /* 品牌列表 */
  brandList: ShopGoodsBrandListDto[] = [];

  /* 标签筛选值 */
  tagValue = [];
  /* 标签列表 */
  tagList: ShopGoodsTagListDto[] = [];

  /* 分类列表 */
  classList: ShopGoodsClassListDto[] = [];
  /* 分类三级列表 */
  threeLevelList: ShopGoodsClassListDto[] = [];
  /* 分类筛选下商品列表 */
  shopGoodsList: GoodsListOfCategoryDto[] = [];

  selectGoodsList: SelectGoodsOptionsDto[] = [];
  goodsList: GoodsListOfCategoryFormatDto[] = [];

  params = {
    pageIndex: 1,
    pageSize: 20
  };
  refreshing = false;
  loading = false;
  finished = false;
  path = ''

  get totalPrice() {
    let amountMoney = 0;
    if (this.selectGoodsList && this.selectGoodsList.length > 0) {
      this.selectGoodsList.forEach((item) => {
        if (item.orderPrice) {
          amountMoney = Number(
            math.mathAdd(
              amountMoney,
              math.mathMultiply(item.orderPrice, item.saleAmount || 0)
            )
          );
        }
      });
    }
    return amountMoney;
  }

  created() {
    this.customerId = this.$route.query.customerId as string;
    this.selectGoodsList = JSON.parse(JSON.stringify(this.selectList));
    this.getClassList();
    this.getBrandList();
    this.getGoodsList();
  }

  getContainer() {
    return document.querySelector(".goods-container");
  }

  /**
   * 排序方式
   * @param val
   */
  changeSortValue(val: string) {
    if (val === "") {
      this.orderField = "";
      this.orderType = "";
    } else {
      const typeArr = val.split("-");
      this.orderField = typeArr[0];
      this.orderType = typeArr[1];
    }
    this.getGoodsList();
  }

  handleBack() {
    // 先去掉一条历史记录，再做页面跳转
    this.$router.go(-1);
    const path = window.sessionStorage.getItem("toPath");
    this.$router.replace({
      path: path,
      query: {
        fromPath: "2",
        totalPrice: String(this.totalPrice)
      }
    });
  }

  /**
   * 获取商品分类列表
   * */
  getClassList() {
    const param = {
      companyId: this.companyId,
      categoryLevel: "0",
      isPage: false
    };
    getShopGoodsClassLis(param, false).then((res) => {
      this.classList = res.data || [];
      this.initClassList();
    });
  }

  /**
   * 初始化商品分类列表
   */
  initClassList() {
    if (this.classList && this.classList.length > 0) {
      this.classList.forEach((item) => {
        item.isCollapse = false;
      });
      this.classList = JSON.parse(JSON.stringify(this.classList));
    }
  }

  /**
   * 切换二级分类展开状态
   * @param index 下标
   */
  collapseChange(index: number) {
    if (this.classList[index].isCollapse) {
      this.$set(this.classList[index], "isCollapse", false);
    } else {
      this.$set(this.classList[index], "isCollapse", true);
    }
  }

  /**
   * 选择分类改变当前左侧选中的分类id
   * @param obj 分类数据
   */
  async changeId(obj: ShopGoodsClassListDto) {
    this.threeId = "";
    // 手动添加的商品分类（全部、新品上架、热卖推荐）
    if(obj && typeof obj === 'string') {
      if (this.categoryId === obj) return false
      this.categoryId = obj
      this.parentId = ''
      this.currentLevel = ''
    } else if(obj && typeof obj !== 'string')  { // 接口获取的商品分类
      if (this.categoryId === obj.categoryId) return false;
      this.categoryId = obj.categoryId;
      this.parentId = obj.parentId;
      this.currentLevel = obj.categoryLevel;
      this.hierarchyId = obj.hierarchyId;
    } else {
      if (this.categoryId === "") return false;
      this.categoryId = "";
      this.parentId = "";
      this.currentLevel = "1";
      this.hierarchyId = "";
      this.hierarchyIdThree = "";
    }

    if (this.currentLevel === "2" && obj.children && obj.children.length > 0) {
      this.threeLevelList = obj.children;
    } else {
      this.threeLevelList = [];
    }

    this.params.pageIndex = 1;
    await this.getGoodsList();
  }

  /**
   * 选择三级分类改变选中的分类id
   * @param id 三级分类id
   * @param level 三级分类级别
   */
  changeThreeId(id: string, level: string, hierarchyId: string) {
    if (this.threeId === id) return false;
    this.params.pageIndex = 1;
    this.threeId = id;
    this.currentLevel = level;
    this.hierarchyIdThree = hierarchyId;
    this.getGoodsList();
  }

  /**
   * 获取分类筛选下商品列表
   */
  getGoodsList() {
    // 获取请求对象（请求接口，请求参数）
    let apiObj = this.getApiObj()
    console.log(477, apiObj)
    apiObj.api(apiObj.params).then((res) => {
      this.refreshing = false
      this.shopGoodsList = (res.data && res.data.records) || []
      this.initGoodsList()
      if (this.shopGoodsList.length >= res.data.totalRecords) {
        this.finished = true;
      } else {
        this.finished = false
      }
      console.log(591,this.goodsList)

    }).catch(() => {
      this.refreshing = false
    })
  }

  /**
   * @description: 获取请求对象（请求接口，请求参数）
   * @param {*}
   * @return {*}
   */
  getApiObj () {
    let params // 请求参数
    let api //  请求接口
    switch (this.categoryId) {
      //  新品上架/热卖推荐不需要品牌和标签查询条件
      case 'xpsj':
      case 'rmtj':
        // 此处经讨论修改为调取getGoodsListOfCategoryAPI tagIdList选择新品上架/热卖推荐
        // params = {
        //   customerId: this.customerId,
        //   shopId: this.companyId,
        //   orderField: this.orderField,
        //   orderType: this.orderType,
        //   ...this.params
        // }
        // api = this.categoryId === 'xpsj' ? newArrivalList : hotSaleList
        params = {
          categoryId: '',
          hierarchyId: '',
          isRecurQuery: true,
          customerId: this.customerId,
          providerId: this.companyId,
          orderField: this.orderField,
          orderType: this.orderType,
          ...this.params,
          brandIdList: [],
          tagIdList: [{
            tagId: this.categoryId=== 'xpsj' ? this.tagList[0].tagId : this.tagList[1].tagId
          }]
        }
        api = getGoodsListOfCategoryAPI
        break;
      default:
        params = {
          categoryId: this.currentLevel === '3' ? this.threeId : this.categoryId,
          hierarchyId:this.currentLevel === "3" && this.hierarchyIdThree ? this.hierarchyIdThree : this.hierarchyId,
          isRecurQuery: true,
          customerId: this.customerId,
          providerId: this.companyId,
          orderField: this.orderField,
          orderType: this.orderType,
          ...this.params,
          brandIdList: this.brandValue.map((item) => {
            return { brandId: item }
          }),
          tagIdList: this.tagValue.map((item) => {
            return { tagId: item }
          })
        }
        api = getGoodsListOfCategoryAPI
    }
    return { api, params }
  }


  /**
   * 筛选刷新
   * */
  reloadList() {
    this.params.pageIndex = 1;
    this.getGoodsList();
  }

  /**
   * 获取初始化下拉选项
   */
  getBrandList() {
    const obj = {
      companyId: this.companyId,
      isPage: false
    };
    getShopGoodsBrandList(obj, false).then((res) => {
      this.brandList = res.data;
    });
    getShopGoodsTagList(obj, false).then((res) => {
      this.tagList = res.data;
      console.log(575,this.tagList)
    });
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1;
    this.refreshing = true;
    this.getGoodsList();
  }

  /**
   * 上拉加载更多
   * */
  onLoad() {
    this.params.pageIndex++;
    this.loading = true;
    // 获取请求对象（请求接口，请求参数）
    let apiObj = this.getApiObj()
    apiObj.api(apiObj.params).then((res) => {
      this.refreshing = false
      this.shopGoodsList = this.shopGoodsList.concat(res.data.records)
      this.initGoodsList()
      if (this.shopGoodsList.length >= res.data.totalRecords) {
        this.finished = true;
      } else {
        this.finished = false
      }
    }).catch(() => {
      this.refreshing = false
    })
  }

  initGoodsList() {
    console.log(589, this.shopGoodsList)
    this.goodsList = this.shopGoodsList.map((item) => {
      if(item.packageList) {
        return {
          goodsId: item.goodsId,
          goodsName: item.goodsName,
          imageNameUrl: item.imageNameUrl,
          versionId: item.versionId,
          // @ts-ignore
          saleAmount: item.packageList[0].minimum || 1,
          orderPrice: item.packageList[0].orderPrice,
          packageId: item.packageList[0].packageId,
          packageName: item.packageList[0].packageName,
          packageNameDesc: item.packageList[0].packageNameDesc,
          minimum: item.packageList[0].minimum,
          maximum: item.packageList[0].maximum
        };
      } else {
        return {
          goodsId: item.goodsId,
          goodsName: item.goodsName,
          imageNameUrl: item.goodsMainImage,
          // @ts-ignore
          orderPrice: item.goodsPrice,
          saleAmount: 1,
        };
      }
    });
  }

  showBuyCar() {
    if (!this.selectGoodsList || this.selectGoodsList.length <= 0) {
      return this.$toast("请先选择商品");
    }
    (this.$refs.buyCarPop as any).show({
      data: this.selectGoodsList
    });
  }

  toSearch() {
    this.setSelectList(this.selectGoodsList);
    this.$router.push({
      path: "searchGoodList",
      query: {
        customerId: this.customerId
      }
    });
  }

  // addFunc (el, data, index) {
  addFunc(data, index) {
    (this.$refs.buyCarDialog as any).show({
      customerId: this.customerId,
      shopId: this.companyId,
      goodsName: this.goodsList[index].goodsName,
      data: data,
      selectGoodsList: this.selectGoodsList
    });
    // ;(this.$refs.buyCarPop as any).drop(el)
  }

  getPackageData(data: SelectGoodsOptionsDto) {
    const list = this.selectGoodsList;
    if (this.selectGoodsList && this.selectGoodsList.length > 0) {
      const existIndex = this.selectGoodsList.findIndex(
        (item) => item.packageId === data.packageId
      );
      if (existIndex !== -1) {
        data.saleAmount = this.selectGoodsList[existIndex].saleAmount + 1;
        list.splice(existIndex, 1, data);
      } else {
        data.saleAmount = data.minimum || 1;
        list.push(data);
      }
    } else {
      data.saleAmount = data.minimum || 1;
      list.push(data);
    }
    this.selectGoodsList = JSON.parse(JSON.stringify(list));
    // 套餐选择改变时,商品展示的套餐信息和价格也要随之改变
    let selectIndex= this.goodsList.findIndex(
      (item) => item.goodsId === data.goodsId
    )
    console.log(this.selectGoodsList)
    this.setSelectList(this.selectGoodsList);
    this.$set(this.goodsList,selectIndex,data)
  }

  sureFunc() {
    if (this.selectGoodsList && this.selectGoodsList.length > 0) {
      this.setSelectList(this.selectGoodsList);
      // 先去掉一条历史记录，再做页面跳转
      this.$router.go(-1);
      const path = window.sessionStorage.getItem("toPath");
      this.$router.replace({
        path: path,
        query: {
          fromPath: "2",
          totalPrice: String(this.totalPrice)
        }
      });
    } else {
      return this.$toast("请先选择商品");
    }
  }

  /**
   * js调用原生api跳转二维码扫描页面方法
   */
  getQRCode() {
    // this.$router.push({
    //     path: '/barCodeGoodList',
    //     query: {
    //         customerId: this.customerId,
    //         barcode: 'mi10x64g'
    //     }
    // })
    this.setSelectList(this.selectGoodsList);
    this.$bridge.callHandler("toQRCodePage", {}, (res: string) => {
      console.log(res, "条形码");
      if (res) {
        this.$router.push({
          path: "/barCodeGoodList",
          query: {
            customerId: this.customerId,
            barcode: res
          }
        });
      }
    });
  }

  beforeRouteEnter(to,form,next){
    console.log(form)
    next(vm =>{
      vm.path = form.path
    })
  }
}
